import type {UseFetchOptions} from "#app";

export const useApiProtectionExists = (keyword: string) => {
    return useHttp.get<boolean>('/protection/exists', {
        params: {
            name: keyword
        },
    })
}

export const useApiCertExist = (keyword: string) => {
    return useHttp.get<boolean>('/service/has', {
        params: {
            provider: keyword
        }
    })
}

export type ServiceDto = {
    id: number;
    agent_id: number;
    product_id: number;
    certificate_type_id: number;
    name: string;
    phone: string;
    code: string;
    provider: string;
    number: string;
    start_time: string;
    exit_time: string;
    img: string;
    carrier: string;
    cost_integral: number;
}

export type Service = {
    id: number;
    agentId: number;
    productId: number;
    certificateTypeId: number;
    name: string;
    phone: string;
    code: string;
    provider: string;
    number: string;
    startTime: string;
    exitTime: string;
    img: string;
    carrier: string;
    costIntegral: number;
};

export const useApiFetchCertByNumber = async (number: string) => {
    return useHttp.get<ServiceDto | null>('/service/get-by-number', {
        params: {
            number
        }
    }).then(res => {
        const {data: serviceDto} = res
        let newData = serviceDto.value ? serviceDto2Service(serviceDto.value) : null;
        return {
            ...res,
            data: ref(newData)
        }
    })
}

export type CertShowImgRes = {
    showCertificateUrl: string
    downloadUrl: string
}

export const useApiFetchCertShowImg = (id: number) => {
    return useHttp.get<CertShowImgRes>(`/service/certificate-img-by-id/${id}`)
}

export type PolicyNews = {
    id: number;
    title: string;
    content: string;
}
const policyNewsList: PolicyNews[] = [
    {
        "id": 1,
        "title": "李强总理《政府工作报告》：开展“人工智能+”行动",
        "content": "李强总理代表国务院在十四届全国人大二次会议上作的《政府工作报告》提出：“深化大数据、人工智能等研发应用，开展‘人工智能+’行动，打造具有国际竞争力的数字产业集群。”人工智能是新质生产力的重要驱动力和新引擎，加快发展新一代人工智能，对于深入推动高质量发展具有重要意义。当前，人工智能存在着数据基础还不够全、技术实力还不够硬、产业发展还不够强、人才支撑还不够牢、治理体系还不够优的问题，急需推进数据链、技术链、产业链、人才链、机制链“五链融合”，以助推“人工智能+”行动的科学实施，更好赋能新质生产力发展。",
    },
    {
        "id": 2,
        "title": "人民日报丨江苏等多地为人工智能发展提供要素支撑",
        "content": `习近平总书记强调，人工智能是新一轮科技革命和产业变革的重要驱动力量，加快发展新一代人工智能是事关我国能否抓住新一轮科技革命和产业变革机遇的战略问题。去年底召开的中央经济工作会议提出，要大力推进新型工业化，发展数字经济，加快推动人工智能发展。今年的《政府工作报告》提出，深化大数据、人工智能等研发应用，开展“人工智能+”行动，打造具有国际竞争力的数字产业集群。<br/>近年来，各地区各部门有针对性地出台一系列政策举措，积极推动资金要素向人工智能领域流动，加强创新链与资金链深度融合，助力人工智能产业高质量发展。<br/>量身定制金融服务，优化科技创投生态圈:<br/>从搬运上料到螺丝锁付，再到视觉质检和电路板焊锡……高效协同完成一系列高强度复杂精细生产工作的，是一个个搭载协作机器人的“柔性小工”。忙碌的“柔性小工”自重只有21千克，功率仅为传统工业机器人的1/4，却在各自的“工作站”中，分工明确又环环相扣地完成全链条组装工作。<br/>发挥财政资金引导作用，促进资本、人才要素聚集:<br/>输入一段文字，一条视频即刻生成。视频里，人物表情生动，运动镜头流畅……在四川省成都恒图科技有限责任公司会议室里，创始人段江展示了一段时长41秒、带有字幕和配音的人工智能生成视频。用户输入文字提示词后，Clipfly先将提示词生成图片，也就是视频帧，再将图片生成视频片段。展示结束后，算法工程师、软件开发和测试人员开始讨论Clipfly的更新升级。<br/>汇聚政策合力，破解融资难点堵点:<br/>人工智能不仅其自身市场前景可观，更对赋能制造业发展和传统产业升级具有重要作用。加快推动人工智能落地应用，全方位推动相关产业发展，各地各部门纷纷拿出务实举措：<br/>北京市提出发挥政府投资基金引导作用，支持长期资本、耐心资本面向人工智能芯片、框架和核心算法开展早期硬科技投资，持续做好人工智能企业挂牌上市培育工作；深圳市提出加大财政资金投入力度，形成规模达1000亿元的人工智能基金群，鼓励相关企业在境内外开展多层次股权融资……<br/>专家表示，未来，推动人工智能高质量发展，还要结合该领域特征，进一步精准施策、凝聚政策合力，有针对性地打通融资难点堵点。`,
    },
    {
        "id": 3,
        "title": "中经评论：“人工智能+”不止是加法",
        "content": `今年，“人工智能+”首次被写入《政府工作报告》，这个新提法为发展数字经济、推进数实融合指明了新路径。值得注意的是，“人工智能+”不是简单相加，而是要通过新技术催生新质生产力，为经济社会各个领域带来新产业、新模式、新动能，发挥出乘数效应。<br/>从“互联网+”到“智能+”再到“人工智能+”，概念之变体现了时代之变、科技之变。2015年《政府工作报告》首提“互联网+”行动计划，彼时移动互联网蓬勃发展，迅速融入传统产业和民生领域，电子商务、互联网金融等新产业、新模式势头强劲。2019年《政府工作报告》又提出拓展“智能+”，重点在于乘势而上，靠加速落地的工业互联网，推动制造业转型升级。今年《政府工作报告》强调“人工智能+”，则要用当前火热的人工智能技术赋能千行百业，发展新质生产力。这一个个“+”，是对新一轮科技革命和产业变革的把握，也是对经济新动能的敏锐判断。<br/>为什么是“人工智能+”？因为这是当下全球科技竞争的焦点。ChatGPT仍在不断演进，Sora又惊艳登场，通用人工智能技术的“车轮”滚滚向前，人工智能大模型迈向规模应用。毋庸置疑，人工智能就是当下那个“最靓的仔”，是重塑全球竞争新格局的关键引擎之一。我国人工智能已具备深入赋能的能力。2023年，人工智能核心产业规模5787亿元，相关企业数量4482家，产业链覆盖芯片、算法、数据、平台、应用等上下游关键环节，细分领域不断突破。尤其是，经过多年培育，行业经历了数字化、智能化转型，进入了人工智能化转型阶段。<br/>“人工智能+”什么？是千行百业，是经济社会各个领域，是无限可能。比如，人工智能+制造业，能改变制造业生产模式和经济形态，提高生产效率，降低生产成本，实现个性化定制，提升产业国际竞争力；人工智能+交通，将打开智慧交通新世界的大门，提供更加敏捷、高效、绿色、安全的出行环境；人工智能+教育，会打破传统的教学方式，提升教育质量，促进教育公平，培养创新人才。人工智能的发展史也告诉我们，只有赋能千行百业，结合各种场景，才能发挥出更大价值。<br/>“人工智能+”不能止步于加法。在“互联网+”“智能+”的实践中，不乏技术、产业“两张皮”的案例。比如，为了实现“智能+”，企业盲目上马一套智能系统，投资巨大，但新系统可能长期浮于简单的连接和设备管理等，或是很难实现行业扩展，甚至出现不好操作、不匹配企业实际情况等问题，不仅无法提升企业竞争力，甚至是在做减法。人工智能要走进企业行业，深入千家万户，与具体的业务流程、产品功能等结合，在不同场景中锤炼升级，才能加出现实生产力，进而带来技术、产业、要素变革，发挥出乘法效应。<br/>总而言之，“人工智能+”需要更多投入、更多规范，也承载着更多期待，在我们面前展现的未来世界将超乎想象。`,
    },
    {
        "id": 4,
        "title": "“人工智能+”行动，激活新质生产力发展强引擎",
        "content": "“我想借这个场合向吴文俊院士致敬，用视觉智能和语言智能向他致敬。”4月13日，斩获2023吴文俊人工智能科学技术奖最高成就奖的鹏城实验室主任、中国工程院院士高文在第十三届吴文俊人工智能科学技术奖颁奖典礼上感慨：多年后，吴院士开创的几何系定理证明先河，在世界人工智能发展中仍有重要的借鉴价值。<br/>4月13日至14日，第十三届吴文俊人工智能科学技术奖颁奖典礼暨2023中国人工智能产业年会在苏州举行，共评出70个获奖项目成果，涉及生成式AI、大模型和通用人工智能等重点领域。“今年的《政府工作报告》首次将开展‘人工智能+’行动写入其中，人工智能已成为我国加快发展新质生产力的核心驱动力。”中国人工智能学会党委书记、中国工程院院士赵春江说。新一轮人工智能新技术浪潮已至，数字技术和实体经济深度融合加速，为新质生产力发展提供新的澎湃动能。<br/>人工智能为高质量发展开辟新赛道:<br/>“过去数十年，人工智能的研究发展既有深刻的理论创新，也有引人注目的技术变革。技术变革和需求驱动促使我们在科研攻关中把握规律、寻找真理，更好地应对人工智能研究的挑战。”在高文看来，在新一轮人工智能浪潮中，中国已经有了与世界同步发展的实力。“我们要和全世界人工智能同步推进，迎接通用人工智能‘奇点’的到来。”<br/>然而，没有算力，就没有推动人工智能发展的动力。高文介绍，当前人工智能驱动的数据密集型创新研究，都是由算力带来的革新。在数字经济时代，算力网是一项前沿性技术，加快全国一体化算力网的建设和应用，将大大加快产业创新步伐、推动新质生产力发展，“而要想让用户像用电一样使用算力，就要搭建安全高效的算力网络，解决人工智能大模型训练的智算问题。比如鹏城实验室建设的智算平台，支持人工智能大模型开源、开放和共享，助力国产自主创新的大模型生态发展”。<br/>当前，江苏各地也在加紧推动算力建设。近日，南京中科逆熵科技有限公司传来好消息，其运营的南京智能计算中心二期已基本建成，算力达到每秒90亿亿次（十六进制），成为长三角地区已经投入运营的规模最大、算力最强的全国产化智算中心。而苏州正加快推进“三核三区两基地”算力空间布局，在苏州国科综合数据中心有限公司，4000多个服务器机柜可提供通用计算、传统超算以及智能算力，已累计服务600余家企业。去年发布的《苏州市关于推进算力产业发展和应用的行动方案》提出，到2025年，全市数据中心总规模达到50万标准机架，算力产业创新集群规模达4000亿元。<br/>“人工智能是引领未来的新兴战略性技术，是驱动科技革命和产业变革的关键变量。”中国科协党组副书记束为说，加强人工智能和产业发展融合，为高质量发展提供新动能。人工智能作为新型工业化的重要推动力，更是新质生产力建设的核心驱动力。创新驱动，数智强国，推动人工智能产业高质量发展，是学术界和产业界共同的机遇。“因此，要畅通产学融合之路，衔接人工智能理论创新、技术创新与场景创新，塑造新兴产业优势，赋能传统产业高端化、智能化、绿色化转型，助力人工智能精准嵌入现代化产业体系。”<br/>人工智能应用落地加速:<br/>近年来，人工智能已不再只是存在于科幻故事中的“空中楼阁”，而是实实在在走进了人们的日常生活。工业和信息化部数据显示，2023年，我国生成式人工智能的企业采用率已达15%，市场规模约为14.4万亿元。赵春江院士表示，促进我国人工智能科技成果产业化，要面向地方传统产业数字化转型的需求，加速人工智能核心技术攻关，着力解决人工智能重大应用和产业化的问题，推动通用人工智能与未来产业实体经济融合发展，加快推进人工智能场景创新和高水平应用，助推一批前沿重点应用示范项目产业化落地。<br/>面向未来的人工智能之路日益清晰:<br/>当前，人工智能发展枝蔓渐盛。未来，什么才是人工智能发展的方向？在其中可能遇到什么样的暗礁？<br/>当前大模型发展如火如荼。“大模型是当下人工智能从弱到强的重要技术路线，但我们也要冷静地分析大模型存在的固有缺陷，需要思考国家未来人工智能发展除了大模型以外，能否开辟其他新的技术路线？”中国工程院院士、同济大学校长郑庆华有着前瞻性的看法。他分析，大模型依托大数据、大算力和强算法，除了内容生成以外，也为科学研究和计算提供了强大的武器。“比如蛋白质精确结构的预测，过去可能要几个月，要数以千计的人才能完成，今天在大模型分析支持下，用几分钟就可以生成这样的结构。”",
    },
    {
        "id": 5,
        "title": "开启“人工智能+”的无限可能",
        "content": "党的十八大以来，以习近平同志为核心的党中央准确把握时代大势，紧抓科技创新的战略机遇，作出一系列促进人工智能发展的重要部署，把新一代人工智能作为推动科技跨越发展、产业优化升级、生产力整体跃升的驱动力量。<br/>从2015年政府工作报告提出“互联网+”，到2019年出现在政府工作报告中的“智能+”，再到今年全国两会，“开展‘人工智能+’行动”首次写入政府工作报告，这背后不仅是科技之变，更是产业之变、时代之变。在加快发展新质生产力的当下及未来，人工智能作为面向未来赛道的技术，无疑是重要引擎之一。<br/>我国产业链完备、市场超大，场景丰富、数据海量，人工智能在很多产业领域具备落地的优势，但也面临大模型技术底座不牢、数据基础较为薄弱、算力仍需提升等困难。如何优化总体设计，加强统筹部署，加快形成竞争优势？如何重塑场景、行业和现代产业格局，抢占全球人工智能发展制高点？4月26日，九三学社中央、全国政协教科卫体委员会组织召开“深化人工智能多场景应用，提升现代产业高质量发展水平”远程协商会，与会政协委员、专家与部委负责同志深入交流探讨，为人工智能助力产业高质量发展建言献策。<br/>人工智能经过60多年的发展，已抵近“量变”到“质变”临界点，引发各领域体系性变革。政协委员们表示，虽然在基础理论、算力资源、人才储备等方面还存在一定差距，但我们拥有党的坚强领导和集中力量办大事的制度优势，以及强大的市场资源和应用场景优势，已经初步形成算力、数据、算法等大工程集成能力和全产业链布局。政协委员们坚信，只要直面问题、正视差距、扬长补短、系统推进，我们完全可以把握人工智能发展主动，抢占全球人工智能发展的战略制高点。 ",
    },
    {
        "id": 6,
        "title": "中国“人工智能+”主攻方向是智能制造",
        "content": "今年政府工作报告提出，深化大数据、人工智能等研发应用，开展“人工智能+”行动，打造具有国际竞争力的数字产业集群。“人工智能+”行动是被首次提出。工业和信息化部近期表示，今年将开展“人工智能+”行动，促进人工智能与实体经济深度融合，推动人工智能赋能新型工业化。<br/>我国为何要开展“人工智能+”行动？“人工智能+”，“+”什么？怎么“+”？近日，云端会客厅邀请北京大学武汉人工智能研究院副院长、北京大学智能学院教授马修军，中国信通院教授级高级工程师、武汉市数字经济发展研究院副院长谭敏和深圳市数字经济产业促进会产业部部长王嘉，围绕上述话题展开探讨。<br/>专家们认为，人工智能已是大国竞争胜负手，也是发展新质生产力的重要引擎。丰富的应用场景和数据资源是我国发展人工智能最大的优势。目前，我国人工智能正与工业制造进行深度融合，智能制造是需要主攻的方向。<br/>我国为何要开展“人工智能+”行动？人工智能是大国竞争胜负手,是新质生产力的代表<br/>人工智能是引领新一轮科技革命和产业变革的战略性技术，具有溢出带动性强的“头雁”效应。加快人工智能全面赋能新型工业化，对我国发展新质生产力起到决定性作用。人工智能赋能生产要素向多元化、融合化和复杂化方向发展，以生成式人工智能为代表的数字化产业正爆发式增长，越来越多面向应用场景的行业大模型不断涌现，表现出产业价值创造的“乘数倍增效应”。人工智能技术作为新质生产力的代表，极大地促进生产力发展，进而对经济发展、科技创新、国际格局等产生深远的影响，由此带来的改变，将影响到我们每一个人。<br/>“人工智能+”，“+”的是什么？它要像水和电一样, 渗透到工作和生活的每个角落<br/>未来产业是颠覆性的，需要颠覆性的技术去驱动。我国为达到2035年基本实现新型工业化的目标，需要充分发挥“人工智能+”的新引擎作用。在自主能力方面，一方面是要有核心的智能芯片，包括推理芯片、训练芯片等等，目前国内厂家如华为、寒武纪等等都在为之努力；另一方面需要有大模型的支撑，目前国内有类似ChatGLM这样在世界范围内都具有竞争力的模型。国内推动“人工智能+”行动应是协作而不是竞争。人工智能需消耗的资源太大，这只能是大国之间的竞争，城市之间只能协作。<br/>我国推进“人工智能+”积累哪些优势？场景和数据是最大优势，智能制造是主攻方向。<br/>我国的优势在于有丰富的人工智能场景。虽然数据质量可能暂时比不上国外，但未来的人工智能数据不光是自然语言，还有图像、视频、音频以及各行业的感知数据。从多模态、多维度的角度来说，我国在数据资源的广度、深度和规模上远超其他国家，这是我们未来发展人工智能最大的优势。整体来看，我国人工智能的发展水平处在国际第一梯队。<br/>目前，我国人工智能正与工业制造进行深度融合，智能制造正是需要主攻的方向。这是我国人工智能目前对行业或者产业最能带来爆点的应用场景，也是“人工智能+”在产业领域的主要体现，且已积累了一定优势。前两天雷军在小米SU7的发布会上说，他最大的底气在于小米拥有世界上最先进的智能化工厂，也是这个逻辑。",
    }
]
export const useApiFetchPolicyNews = async () => {
    return {
        data: ref(policyNewsList)
    }
}

export type NewsListForm = {
    page: number
    size: number
}
/*
* 这个是后端 Article
* */
export type News = {
    id: number
    name: string
    img: string
    time: string
    text: string
    num: number
    price: number
}

export const uesApiFetchNewsList = (params: NewsListForm, opts?: UseFetchOptions<any>) => {
    return useHttp.get<{
        list: News[]
        total: number
    }>(`/article/list`, {
        ...opts,
        params,
    })
}

export const useApiFetchNewsInfo = (id: number) => {
    return useHttp.get<News>(`/article/${id}`)
}

export const useApiFetchProjectExistByName = (name: string) => {
    return useHttp.get<boolean>(`/project/exists`, {
        params: {
            name
        }
    })
}

export const useApiFetchAgentExistByName = (name: string) => {
    return useHttp.get<boolean>(`/agent/exists`, {
        params: {
            name
        }
    })
}

export type PolicyDocument = {
    id: number;
    img: string;
    bigImg: string;
}

export async function useApiFetchPolicyDocumentList() {
    const config = useRuntimeConfig();
    const baseUrl = config.app.baseURL
    const list: PolicyDocument[] = [
        {
            id: 1,
            img: 'policy1.jpg',
            bigImg: 'policy1_big.jpg'
        },
        {
            id: 2,
            img: 'policy2.jpg',
            bigImg: 'policy2_big.jpg'
        },
        {
            id: 3,
            img: 'policy3.jpg',
            bigImg: 'policy3_big.jpg'
        },
        {
            id: 4,
            img: 'policy4.jpg',
            bigImg: 'policy4_big.jpg'
        },
        {
            id: 5,
            img: 'policy5.jpg',
            bigImg: 'policy5_big.jpg'
        },
    ].map(item => {
        const img = `${baseUrl}img/policy/data/${item.img}`;
        const bigImg = `${baseUrl}img/policy/data/${item.bigImg}`

        return {
            ...item,
            img,
            bigImg
        }
    })


    return {
        data: ref(list)
    };
}

export type Case = {
    id: number
    name: string,
    content: string,
    img: string,
    time: string,
    url: string
}

export type CasePageForm = {
    page: number
    size: number
}

export function useApiFetchCaseList(params: CasePageForm) {
    return useHttp.get<{
        list: Case[],
        total: number
    }>('/cases/page', {
        params
    })
}